module.exports = __webpack_public_path__ + "static/media/hive_roots.e8b7302b.png";